/* Generado desde tokens.json con scripts/generar-tokens.py. No editar a mano. */
export const fct = {
  marca: {
    "verde-oscuro": "#3A511F",
    "verde-base": "#5A7C30",
    "verde-medio": "#8CA36E",
    "verde-tenue": "#E6EBE0",
    lima: "#C2F03D",
    negro: "#0C0C0C"
  },
  isotipo: {
    "1": "#03C25B",
    "2": "#81E1AD",
    "3": "#B3EDCD",
    "4": "#4F91FF",
    "5": "#A6C6FF",
    "6": "#D8E6FF"
  },
  tinta: {
    "900": "#23281E",
    "700": "#4A524D",
    "500": "#6B7361",
    logotipo: "#4A4A48",
    inversa: "#FFFFFF",
    "inversa-suave": "#E6EBE0"
  },
  linea: {
    control: "#8C9580",
    tarjeta: "#D7DCCD",
    fila: "#EEF0E8",
    papel: "#E7E3D6"
  },
  superficie: {
    lienzo: "#E6EBE0",
    tarjeta: "#FFFFFF",
    hundida: "#F1F3EC",
    papel: "#FBFAF6",
    marco: "#26331B",
    rail: "#3A511F"
  },
  rail: {
    icono: "#DCE5CE",
    activo: "#C2F03D"
  },
  trama: {
    lienzo: "#DCE3D2",
    marco: "#2E3E21",
    papel: "#EEEADD"
  },
  interaccion: {
    primaria: "#C2F03D",
    "primaria-hover": "#B5E42F",
    "primaria-activa": "#A6D322",
    "primaria-texto": "#2C3D18",
    secundaria: "#3A511F",
    "secundaria-hover": "#2F4319",
    enlace: "#1C5FD6",
    "enlace-hover": "#164BAB",
    foco: "#1C5FD6",
    "foco-oscuro": "#C2F03D",
    "seleccion-borde": "#4F91FF",
    "seleccion-fondo": "#EAF1FF",
    "fila-resaltada": "rgba(194, 240, 61, 0.12)",
    "fila-grupo": "rgba(90, 124, 48, 0.08)",
    "hover-fila": "#F7F8F4",
    "deshabilitado-fondo": "#F1F3EC",
    "deshabilitado-texto": "#8A9280"
  },
  estado: {
    exito: {
      relleno: "#E6F7E7",
      linea: "#128A44",
      texto: "#0A6B38"
    },
    aviso: {
      relleno: "#FBF1DE",
      linea: "#A06A00",
      texto: "#8A5300"
    },
    riesgo: {
      relleno: "#FFE8E8",
      linea: "#C0392B",
      texto: "#A32219"
    },
    proceso: {
      relleno: "#DAEDED",
      linea: "#026874",
      texto: "#01555F"
    },
    neutro: {
      relleno: "#F1F2F2",
      linea: "#6B736E",
      texto: "#4A524D"
    }
  },
  grafico: {
    "serie-01": "#3A511F",
    "serie-02": "#8CA36E",
    "serie-03": "#0086A8",
    "serie-04": "#BE8710",
    "serie-05": "#8B52B2",
    "serie-06": "#95571E",
    "serie-07": "#4A5FA8",
    "serie-08": "#00806A",
    otros: "#A8B0B6",
    destacado: "#C2F03D",
    caida: "#C0392B",
    carril: "#EEF0E8",
    rejilla: "#EEF0E8",
    eje: "#6B7361",
    "cantidad-1": "#EEF1E9",
    "cantidad-2": "#D6DEC9",
    "cantidad-3": "#A9BB8E",
    "cantidad-4": "#5A7C30",
    "cantidad-5": "#3A511F"
  },
  fuente: {
    interfaz: "Roboto, 'Helvetica Neue', Arial, sans-serif",
    dato: "'Roboto Mono', ui-monospace, 'SFMono-Regular', Consolas, monospace",
    voz: "'Source Serif 4', Georgia, 'Times New Roman', serif",
    logotipo: "Dissolve, Roboto, sans-serif"
  },
  googleFonts: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;1,400&family=Roboto+Mono:wght@400;500&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,600;1,8..60,400&display=swap",
  texto: {
    display: {
      familia: "voz",
      tamano: 40,
      linea: 44,
      peso: 400,
      uso: "Solo piel de cliente"
    },
    "titulo-pagina": {
      familia: "interfaz",
      tamano: 36,
      linea: 40,
      peso: 700,
      uso: "34–40 px. En piel de cliente, voz 600"
    },
    antetitulo: {
      familia: "dato",
      tamano: 11,
      linea: 16,
      peso: 500,
      tracking: "0.16em",
      mayusculas: true
    },
    "titulo-bloque": {
      familia: "interfaz",
      tamano: 24,
      linea: 30,
      peso: 700
    },
    "titulo-tarjeta": {
      familia: "interfaz",
      tamano: 16,
      linea: 22,
      peso: 700
    },
    cuerpo: {
      familia: "interfaz",
      tamano: 15,
      linea: 24,
      peso: 400
    },
    "cuerpo-compacto": {
      familia: "interfaz",
      tamano: 14,
      linea: 20,
      peso: 400
    },
    etiqueta: {
      familia: "interfaz",
      tamano: 13,
      linea: 18,
      peso: 500
    },
    pie: {
      familia: "interfaz",
      tamano: 12.5,
      linea: 18,
      peso: 400
    },
    dato: {
      familia: "dato",
      tamano: 13,
      linea: 18,
      peso: 500
    },
    "dato-compacto": {
      familia: "dato",
      tamano: 12,
      linea: 16,
      peso: 500
    },
    "cifra-kpi": {
      familia: "dato",
      tamano: 28,
      linea: 32,
      peso: 500,
      tracking: "-0.02em"
    },
    "cabecera-tabla": {
      familia: "dato",
      tamano: 10,
      linea: 14,
      peso: 500,
      tracking: "0.1em",
      mayusculas: true
    }
  },
  espacio: {
    "1": 4,
    "2": 8,
    "3": 12,
    "4": 16,
    "5": 20,
    "6": 24,
    "7": 32,
    "8": 40,
    "9": 48
  },
  radio: {
    micro: 4,
    control: 6,
    imagen: 8,
    tarjeta: 10,
    hoja: 12,
    "hoja-movil": 16,
    pastilla: 999
  },
  elev: {
    boton: "0 1px 2px rgba(20,28,10,.22), 0 2px 6px rgba(20,28,10,.10)",
    "1": "0 1px 2px rgba(35,46,20,.06), 0 8px 22px rgba(35,46,20,.07)",
    "2": "0 4px 12px rgba(10,14,6,.14), 0 12px 28px rgba(10,14,6,.12)",
    "3": "0 24px 54px rgba(4,8,4,.30)",
    "3-escena": "0 24px 54px rgba(4,8,4,.40)"
  },
  densidad: {
    comoda: {
      fila: 44,
      "celda-v": 10,
      "celda-h": 14,
      control: 40,
      tarjeta: 20,
      separacion: 12,
      cuerpo: 15,
      dato: 13,
      tarjetas: 16,
      "texto-control": 14
    },
    compacta: {
      fila: 32,
      "celda-v": 5,
      "celda-h": 10,
      control: 32,
      tarjeta: 14,
      separacion: 8,
      cuerpo: 14,
      dato: 12,
      tarjetas: 14,
      "texto-control": 13
    }
  },
  escena: {
    velo: "linear-gradient(115deg, rgba(10,48,34,.70) 0%, rgba(10,48,34,.32) 40%, rgba(10,48,34,0) 72%), linear-gradient(rgba(12,14,12,.36), rgba(12,14,12,.36))",
    foto: "kardia-int-24.jpg"
  },
  anchos: {
    movil: 480,
    tableta: 1024,
    rail: 60,
    lectura: "72ch"
  }
} as const;

export type FctTokens = typeof fct;
export type FctFamiliaEstado = keyof typeof fct.estado;
